/**
 * Video-call constants
 *
 * Centralized constants for the 1:1 chat video-call page. Business-logic values
 * are pulled verbatim from Flutter and must never be invented.
 */

export const VIDEO_CALL_CONSTANTS = {
  /**
   * Seconds to wait for the audience to join before treating the call as
   * unanswered (the "audience did not join" timeout).
   *
   * Mirrors Flutter's `AppConstants.videoCallWaitJoinDurationSeconds = 15`
   * (lib/domain/constants/app_constants.dart:37), used at
   * lib/presentation/screens/chat/video_call_screen.dart:323-330.
   */
  VIDEO_CALL_WAIT_JOIN_DURATION_SECONDS: 15,
} as const;

export type VideoCallConstants = typeof VIDEO_CALL_CONSTANTS;
